import React, { useEffect, useState } from 'react';
import { callAPI } from '../utils/apiUtils';
import { apiUrls } from '../utils/apiUrls';
import { useConnection } from '../offline/connection';
import { canDo } from '../offline/state';

export default function TenderView({ PAYMENT_MODES, orderTypeNum, orderId, onPaymentModeChange, onTenderSelect }) {
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
    const [availablePaymentModes, setAvailablePaymentModes] = useState([]);
    const [selectedTender, setSelectedTender] = useState("");
    // Offline, only what the offline engine says it can take (a no-op online / with no engine): the debit card tile needs a terminal
    // or a hand-recorded EFTPOS payment, the ONLINE tile a payment link, and the out-of-system tenders are not offered at all.
    const { state: offlineState } = useConnection();
    const modeAllowed = (mode) =>
        mode === PAYMENT_MODES.eftpos ? canDo(offlineState, 'cardPayments') || canDo(offlineState, 'manualEftpos')
        : mode === PAYMENT_MODES.online ? canDo(offlineState, 'payLink')
        : true;
    const tenderAllowed = canDo(offlineState, 'outOfSystemTenders');
    const enabledModes = availablePaymentModes.filter(modeAllowed);

    useEffect(() => {
        if (orderTypeNum) fetchConfiguredPaymentMode();
    }, [orderTypeNum]);

    const fetchConfiguredPaymentMode = async () => {
        try {
            const response = await callAPI(`${apiUrls.CONFIGURED_PAYMENT_MODE}?order_type=${orderTypeNum}`, {}, 'GET');
            const data = response.data.data || {};
            const modes = [];

            if (data.is_cash_enabled) modes.push(PAYMENT_MODES.cod);
            if (data.is_eftpos_enabled) modes.push(PAYMENT_MODES.eftpos);
            if (data.is_online_enabled && orderTypeNum !== 3) modes.push(PAYMENT_MODES.online);

            setAvailablePaymentModes(modes);
            selectDefaultPaymentMode(modes.filter(modeAllowed));
        } catch (error) {
            console.error('Error fetching configured payment mode:', error);
        }
    };

    const selectDefaultPaymentMode = (modes) => {
        if (modes.includes(PAYMENT_MODES.eftpos)) {
            selectPaymentMethod(PAYMENT_MODES.eftpos, true);
        } else if (modes.length > 0) {
            selectPaymentMethod(modes[0], true);
        }
    };

    const selectPaymentMethod = (method, force = false) => {
        if (!force && !enabledModes.includes(method)) return;
        setSelectedTender("");
        setSelectedPaymentMethod(method);
        onPaymentModeChange(method);
    };

    const selectTender = (tender) => {
        setSelectedPaymentMethod(PAYMENT_MODES.outofsystem);
        setSelectedTender(tender);

        onTenderSelect({
            paymentMethod: PAYMENT_MODES.outofsystem,
            selectedTender: tender,
        });
    };

    return (
        <div className="col-lg-auto">
            <div className="choosePaymentTrigger">

                
                <button
                    className={`${selectedPaymentMethod === PAYMENT_MODES.cod ? 'active' : ''} 
                                ${!enabledModes.includes(PAYMENT_MODES.cod) ? 'disabled' : ''}`}
                    onClick={() => selectPaymentMethod(PAYMENT_MODES.cod)}
                >
                    <svg width="36" height="30"><use xlinkHref="./images/sprite.svg#iconCash"/></svg>
                    <span className="paymentText">Cash</span>
                </button>

                
                <button
                    className={`${selectedPaymentMethod === PAYMENT_MODES.eftpos ? 'active' : ''} 
                                ${!enabledModes.includes(PAYMENT_MODES.eftpos) ? 'disabled' : ''}${modeAllowed(PAYMENT_MODES.eftpos) ? '' : ' offlineGated'}`}
                    onClick={() => selectPaymentMethod(PAYMENT_MODES.eftpos)}
                >
                    <svg width="44" height="30"><use xlinkHref="./images/sprite.svg#iconCard"/></svg>
                    <span className="paymentText">Debit Card</span>
                </button>

                
                <button
                    className={`${selectedPaymentMethod === PAYMENT_MODES.online ? 'active' : ''} 
                                ${!enabledModes.includes(PAYMENT_MODES.online) ? 'disabled' : ''}${modeAllowed(PAYMENT_MODES.online) ? '' : ' offlineGated'}`}
                    onClick={() => selectPaymentMethod(PAYMENT_MODES.online)}
                >
                    <svg width="30" height="30"><use xlinkHref="./images/sprite.svg#iconQr"/></svg>
                    <span className="paymentText">ONLINE</span>
                </button>

                
                <button
                    className={`${selectedTender === 'doordash' ? 'active' : ''}${tenderAllowed ? '' : ' offlineGated'}`}
                    onClick={() => tenderAllowed && selectTender('doordash')}
                >
                    <svg width="30" height="30"></svg>
                    <span className="paymentText">Doordash</span>
                </button>

                
                <button
                    className={`${selectedTender === 'ubereats' ? 'active' : ''}${tenderAllowed ? '' : ' offlineGated'}`}
                    onClick={() => tenderAllowed && selectTender('ubereats')}
                >
                    <svg width="30" height="30"></svg>
                    <span className="paymentText">Uber Eats</span>
                </button>

                
                <button
                    className={`${selectedTender === 'menulog' ? 'active' : ''}${tenderAllowed ? '' : ' offlineGated'}`}
                    onClick={() => tenderAllowed && selectTender('menulog')}
                >
                    <svg width="30" height="30"></svg>
                    <span className="paymentText">Menulog</span>
                </button>

            </div>
        </div>
    );
}
